// C:\Users\Admin\Desktop\BuildPro\frontend\admin\src\components\config\url.js

export let baseurl = "https://api.ogcs.co.in";
// export let baseurl = "http://localhost:5000";

